export class UserData {
    name: string;
    email: string;
    userId: string;
    errors?: Error[];
}